import { Component, Input, Output, OnDestroy, EventEmitter } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { BuyerState } from '~app/modules/generic/store';
import * as fromStoryblok from '~app/modules/storyblok/store';
import { ApplicationEventService } from '~shared/modules/application-event/services';
import { CategoriesNavbarApplicationEventHandler } from '~app/modules/generic/helpers';
import { Category } from '~app/modules/generic/models';
import {
  APP_ALL_OFFERS_ROUTE,
  APP_CATEGORY_ROUTE,
  APP_LANDING_PAGE_ROUTE,
  FeatureToggleEnum,
  NUMBER_9,
} from '~shared/constants';
import { StoryData } from 'storyblok-js-client';
import { EditorialList, ThematicResources } from '~app/modules/storyblok/models/storyblok-global-content.model';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';

@Component({
  selector: 'app-promo-categories',
  templateUrl: './promo-categories.component.html',
  styleUrls: ['./promo-categories.component.scss'],
})
export class PromoCategoriesComponent implements OnDestroy {
  @Input() selectedCategory: Category;
  @Output() menuClosed = new EventEmitter<null>();

  public MAX_VISIBLE_PROMOTIONS_MENU_ITEMS_COUNT = NUMBER_9;
  public categoryRoute = `/${APP_CATEGORY_ROUTE}`;
  public allOffersRoute = [`/${APP_LANDING_PAGE_ROUTE}/${APP_ALL_OFFERS_ROUTE}`];

  private readonly destroySubject = new Subject<boolean>();
  private applicationEventHandler: CategoriesNavbarApplicationEventHandler;

  public editorialList: EditorialList;
  public thematicResources: ThematicResources;

  constructor(
    private store: Store<BuyerState>,
    private translateService: TranslateService,
    applicationEventService: ApplicationEventService,
    private featureFlagService: ActiveFeaturesConfigcatService
  ) {
    this.applicationEventHandler = new CategoriesNavbarApplicationEventHandler(
      applicationEventService,
      this.translateService
    );

    this.setOfferMenuContent();
  }

  setOfferMenuContent(): void {
    this.store
      .pipe(select(fromStoryblok.getOfferMenuContent), takeUntil(this.destroySubject))
      .subscribe((offerMenuContent: StoryData) => {
        if (offerMenuContent?.content?.global?.length) {
          this.editorialList = offerMenuContent?.content?.global?.[0].editoriallist?.[0];
          this.thematicResources = offerMenuContent?.content?.global?.[0].thematicresources?.[0];
        }
      });
  }

  closeMenu(): void {
    this.menuClosed.emit();
  }

  fireAllPromotionsClickEvent(selectedCategoryName: string, label?: string): void {
    this.applicationEventHandler.publishAppNavigation(selectedCategoryName, label);
    this.closeMenu();
    this.applicationEventHandler.publishSeeAllPromotion();
  }

  firePromoCategoryClickEvent(nestedCategoryName: string, parentCategoryName: string): void {
    this.applicationEventHandler.publishAppNavigation(`${parentCategoryName}/${nestedCategoryName}`);
    this.closeMenu();
    this.applicationEventHandler.publishPromotionCategorySelected(nestedCategoryName);
  }

  ngOnDestroy(): void {
    this.applicationEventHandler.destroy();
    this.closeMenu();
    this.destroySubject.next();
    this.destroySubject.complete();
  }
}
